export interface MatchIndex {
  startIdx: number;
  endIdx: number;
}

export type PartType = "highlight" | "normal";

export interface HighlightPart {
  text: string;
  type: PartType;
}

export function getMatchIndexes({
  text,
  highlight,
}: {
  text: string;
  highlight: string;
}): MatchIndex[] {
  let highlightRegexText = "";
  highlight?.split(" ").forEach((d, idx) => {
    if (idx > 0) {
      highlightRegexText += `|^` + d + `|\\s` + d;
    } else {
      highlightRegexText = `^` + d + `|\\s` + d;
    }
  });
  const matchRegex = new RegExp(`${highlightRegexText}`, "ig");
  const matches = text?.matchAll(matchRegex);
  const indexes: MatchIndex[] = [];
  for (const match of matches) {
    indexes.push({
      startIdx: match?.index ?? 0,
      endIdx: (match?.index ?? 0) + (match?.[0].length ?? 0),
    });
  }
  return indexes;
}

export function getHighlightParts({
  text,
  highlight,
}: {
  text: string;
  highlight: string;
}): { parts: HighlightPart[]; highlightIndexes: MatchIndex[] } {
  const highlightIndexes = getMatchIndexes({ text, highlight });
  const parts: HighlightPart[] = [];
  let lastIdx = 0;

  highlightIndexes.forEach((highlightIdx) => {
    if (lastIdx === highlightIdx.startIdx) {
      parts.push({
        text: text?.slice(highlightIdx.startIdx, highlightIdx.endIdx) ?? "",
        type: "highlight",
      });
      lastIdx = highlightIdx.endIdx;
    } else {
      parts.push({
        text: text?.slice(lastIdx, highlightIdx.startIdx) ?? "",
        type: "normal",
      });
      parts.push({
        text: text?.slice(highlightIdx.startIdx, highlightIdx.endIdx) ?? "",
        type: "highlight",
      });
      lastIdx = highlightIdx.endIdx;
    }
  });

  if (lastIdx < text?.length) {
    parts.push({
      text: text?.slice(lastIdx, text.length) ?? "",
      type: "normal",
    });
  }

  return { parts, highlightIndexes };
}
